import { media, styled } from '@styles';

import { Container } from '../../templates/Container/Container';

export const Wrapper = styled(Container)`
  padding: 122px 0 125px;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${media.largeScreen`
    padding: 70px 0 78px;
  `}
  ${media.smallScreen`
    padding: 60px 0 60px;
  `}
`;

export const Icon = styled.img`
  ${media.largeScreen`
    max-width: 45px;
  `}
`;

export const Title = styled.h1`
  margin-top: 41px;
  font-family: ${(props) => props.theme.typography.thinFontFamily};
  font-size: ${(props) => props.theme.typography.h1FontSize};
  ${media.largeScreen`
    margin-top: 15px;
    letter-spacing: -0.5px;
  `}
  ${media.smallScreen`
    margin-top: 17px;
  `}
`;

export const SubTitle = styled.h6`
  margin-top: 35px;
  max-width: 522px;
  font-family: ${(props) => props.theme.typography.extraFontFamily};
  font-size: ${(props) => props.theme.typography.baseFontSize};
  font-weight: normal;
  text-align: center;
  line-height: 160%;
  ${media.largeScreen`
    margin-top: 11px;
  `}
`;
